import React from 'react';


const WaviyText = ({ text }) => {
  return (
    <p className="waviy">
      {text.split('').map((char, index) => (
        <span key={index} style={{ '--i': index + 1 }}>
          {char}
        </span>
      ))}
    </p>
  );
};

export default WaviyText;
